// components/DesignMyNight.vue
<template>
  <div ref="container" class="bbb-dmn-booking-container">
    <div v-if="!loaded" class="dmn-loading">
      Loading booking widget...
    </div>
  </div>
</template>

<script>
export default {
  name: 'DesignMyNight',
  props: {
    venue: {
      type: String,
      required: true
    },
    hideOffers: {
      type: [Boolean, String],
      default: false
    },
    hidePoweredBy: {
      type: [Boolean, String],
      default: false
    },
    searchVenues: {
      type: [Boolean, String],
      default: false
    },
    mondayFirst: {
      type: [Boolean, String],
      default: true
    },
    locale: {
      type: String,
      default: 'undefined'
    }
  },
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.loadBookingWidget();
    });
  },
  methods: {
    loadBookingWidget() {
      // Helper to convert string 'true'/'false' to actual boolean
      const toBool = (val) => {
        if (typeof val === 'string') {
          return val.toLowerCase() === 'true';
        }
        return !!val;
      };

      // Create the script element
      const script = document.createElement('script');
      script.src = '//widgets.designmynight.com/bookings-partner.min.js';
      script.setAttribute('dmn-booking-form', 'true');
      script.setAttribute('venue', this.venue);
      script.setAttribute('hide-offers', toBool(this.hideOffers).toString());
      script.setAttribute('hide-powered-by', toBool(this.hidePoweredBy).toString());
      script.setAttribute('search-venues', toBool(this.searchVenues).toString());
      script.setAttribute('monday-first', toBool(this.mondayFirst).toString());
      script.setAttribute('locale', this.locale);

      // Append to our component container
      this.$refs.container.appendChild(script);
      this.loaded = true;
    }
  }
}
</script>

<style scoped>
.dmn-loading {
  padding: 20px 0;
  text-align: center;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// assets/js/components/DesignMyNight.vue